<template>
	<div>
		<v-app-bar dense class="appStudyBar">
			<v-toolbar-title>
				<v-btn class="btn-default" icon @click="$router.push('/landing')" text title="home" height="38" width="38"><v-icon>home</v-icon></v-btn>
			</v-toolbar-title>
			<h1 style="color:white">
				<label for="selectedStudyUuidName">Study:</label>
			</h1>
			<v-toolbar-title >
				<v-autocomplete
					ref="autocompleteStudy"
					class="study-autocomplete"
          v-model="selectedStudyUuid"
					:items="studies"
          item-text="studyNames"
					item-value="studyUuids"
					hide-details
					id="selectedStudyUuidName"
					@change="setNull"
					aria-labelledby="selectedStudyUuidName"
					aria-autocomplete="list"
					aria-activedescendant="selectedStudyUuid"
					:aria-expanded=isExpanded
					:title="'Study Name, ' + studiesFound"
					@focus=checkExpanded
					@click=checkExpanded
					@blur=checkExpanded
					@update:list-index=checkExpanded
					@update:search-input=checkExpanded
					role="combobox"
					aria-haspopup="listbox"
					no-data-text="No Studies Found"
        >
				</v-autocomplete>
			</v-toolbar-title>
		</v-app-bar>
	</div>
</template>
<script>
/**
 * The nav bar holding the home button and the study dropdown.
 */
export default {
	name: 'AppStudyBar',
	data: () => ({
		selectedStudyUuid: null,
		isExpanded: 'false',
		studiesFound: ''
	}),
	async mounted () {
		var userId = await this.$store.getters.getUserId;
		await this.$store.dispatch('loadUserInfo', userId);
		this.isExpanded = this.$refs.autocompleteStudy.isMenuActive.toString()
	},
	watch: {
		selectedStudyUuid: function (newVal, oldVal) {
			if (newVal) { // took out the need for oldVall to be in the conditional;
				const studyUuid = newVal;
				this.$store.commit('setSelectedStudyUuid', { id: studyUuid });
			}
		}
	},
	created () {
		const selectedStudy = this.$store.getters.getSelectedStudy;
		if (selectedStudy != null) {
			this.selectedStudyUuid = this.$store.getters.getSelectedStudy.studyUuid;
		}
	},
	computed: {
		studies: {
			get: function () {
				return this.$store.getters.getStudyObjects;
			},
			// Setter: this is needed to avoid errors by the autocomplete. It should not change
			// the values in the view
			set: function (newVal) {}
		}
	},
	methods: {
		setNull: function () {
			if (!this.selectedStudyUuid) {
				this.selectedStudyUuid = null
			}
		},
		checkExpanded: function () {
			this.isExpanded = this.$refs.autocompleteStudy.isMenuActive.toString()
			if (this.$refs.autocompleteStudy.computedItems.length === 0) {
				this.studiesFound = 'No Studies Found,'
			} else if (this.$refs.autocompleteStudy.computedItems.length === 1) {
				this.studiesFound = 'Study Found,'
			} else if (this.$refs.autocompleteStudy.computedItems.length > 1) {
				this.studiesFound = 'Studies Found,'
			} else {
				this.studiesFound = ''
			}
		}
	}
}
</script>

<style>
</style>
